// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","flower":"footer-module--flower--2pE8o","spin":"footer-module--spin--1FIpd"};